import React, { useState, useEffect } from 'react';
import './index.css';
import Steps from './Steps';
import DateStepper from './DateStepper';
import GetAdvice from './GetAdvice'

const data = [
  {
    title: 'Title 1',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
  },
  {
    title: 'Title 2',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
  },
  {
    title: 'Title 3',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
  }
]

function App() {

  return <div className='steps-box'>
    <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
    <Steps />
    {/* <DateStepper />
    <GetAdvice /> */}
  </div>
}

export default App;